import React from 'react'
import UserNotifications from '../../CustomerDash/Pages/UserNotifications';

// Vendors share the same notification centre as customers; it switches to the
// vendor menu / cards and vendor routes based on the logged-in user's type.
const VendorNotifications = () => <UserNotifications />

export default VendorNotifications
